import { render, staticRenderFns } from "./BlogCard.vue?vue&type=template&id=4b911204&scoped=true&"
import script from "./BlogCard.vue?vue&type=script&lang=ts&"
export * from "./BlogCard.vue?vue&type=script&lang=ts&"
import style0 from "./BlogCard.vue?vue&type=style&index=0&id=4b911204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b911204",
  null
  
)

export default component.exports